"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9952],{

/***/ 31182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ LocalizedProductsFooterLinks; },
/* harmony export */   "Co": function() { return /* binding */ LocalizedSolutionsFooterLinks; },
/* harmony export */   "Rj": function() { return /* binding */ LocalizedUseCasesFooterLinks; },
/* harmony export */   "kK": function() { return /* binding */ LocalizedProductsHeaderLinks; },
/* harmony export */   "nQ": function() { return /* binding */ LocalizedResourcesLinks; },
/* harmony export */   "yt": function() { return /* binding */ LocalizedOurProductFooterLinksV2; }
/* harmony export */ });
/* unused harmony export getLocalizedLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72632);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_localization__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27639);
/* harmony import */ var constants_work_managment_logos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74329);





var SPANISH_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var FRENCH_HELP_CENTER_LINK = "//support.monday.com/hc/fr";
var PORTUGEESE_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var GERMAN_HELP_CENTER_LINK = "//support.monday.com/hc/de";
var JAPANESE_HELP_CENTER_LINK = "//support.monday.com/hc/ja";
var SPANISH_BLOG_LINK = "//monday.com/blog/es/";
var PORTUGEESE_BLOG_LINK = "//monday.com/blog/pt/";
var FRENCH_BLOG_LINK = "//monday.com/blog/fr/";
var GERMAN_BLOG_LINK = "//monday.com/blog/de/";
var JAPANESE_BLOG_LINK = "//monday.com/blog/ja/";
var SPANISH_WORK_OS_LINK = "//monday.com/blog/es/work-os/";
var PORTUGEESE_WORK_OS_LINK = "//monday.com/blog/pt/work-os-uma-plataforma-para-o-futuro-do-trabalho/";
var FRENCH_WORK_OS_LINK = "//monday.com/blog/fr/le-work-os-lavenir-du-travail/";
var _obj;
var LocalizedResourcesLinks = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    "header.blog": {
        href: SPANISH_BLOG_LINK
    },
    "header.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: SPANISH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    "header.blog": {
        href: PORTUGEESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: PORTUGEESE_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    "header.blog": {
        href: FRENCH_BLOG_LINK
    },
    "header.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: FRENCH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID, {
    "header.blog": {
        href: GERMAN_BLOG_LINK
    },
    "header.helpCenter": {
        href: GERMAN_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: GERMAN_BLOG_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.JAPANESE_LOCALE_ID, {
    "header.blog": {
        href: JAPANESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: JAPANESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: JAPANESE_BLOG_LINK,
        openInNewTab: true
    }
}), _obj);
var DEFAULT_LINKS = {
    "header.blog": {
        href: "//monday.com/blog"
    }
};
var _obj1;
var LocalizedOurProductFooterLinksV2 = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    "footer.workOS": SPANISH_WORK_OS_LINK
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    "footer.workOS": PORTUGEESE_WORK_OS_LINK
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    "footer.workOS": FRENCH_WORK_OS_LINK
}), _obj1);
// TODO: Temp solution until we refactor the whole footer and header localization mechanism
// for WM Generator vs. Webflow mini site test
var LocalizedProductsHeaderLinks = _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        // Products
        "header.tabs.products.mondayWorkManagement.title": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .WORK_MANAGEMENT_MINI_SITE_LINK */ .ler),
        "header.tabs.products.mondaySalesCRM.title": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .CRM_MINI_SITE_LINK */ .mgz),
        "header.tabs.products.mondayDev.title": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .SOFTWARE_MINI_SITE_LINK */ .DDD),
        // Switcher
        "header.tabs.solutions.byProduct.workManagement": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .WORK_MANAGEMENT_MINI_SITE_LINK */ .ler),
        "header.tabs.solutions.byProduct.crm": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .CRM_MINI_SITE_LINK */ .mgz),
        "header.tabs.solutions.byProduct.dev": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .SOFTWARE_MINI_SITE_LINK */ .DDD),
        // Solutions by team
        "header.tabs.solution.sales": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .CRM_MINI_SITE_LINK */ .mgz),
        "header.tabs.solution.product": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .SOFTWARE_MINI_SITE_LINK */ .DDD),
        "header.tabs.solution.rnd": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .SOFTWARE_MINI_SITE_LINK */ .DDD),
        // Solutions by Company Size
        "header.tabs.solution.enterprise": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .ENTERPRISE_OLD_PAGE_LINK */ .Bhn)
    };
    return acc;
}, {});
var LocalizedProductsFooterLinks = _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        "footer.mondayWorkManagement": {
            href: "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .WORK_MANAGEMENT_MINI_SITE_LINK */ .ler),
            icon: constants_work_managment_logos__WEBPACK_IMPORTED_MODULE_2__/* ["default"].WM_FOOTER_LOGO */ .Z.WM_FOOTER_LOGO
        },
        "footer.mondaySalesCRM": {
            href: "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .CRM_MINI_SITE_LINK */ .mgz),
            icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/crm_icon_footer.png"
        },
        "footer.mondayDev": {
            href: "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .SOFTWARE_MINI_SITE_LINK */ .DDD),
            icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/dev_new_mobile_footer_logo.png"
        }
    };
    return acc;
}, {});
var LocalizedUseCasesFooterLinks = _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        "footer.salesUseCase": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .CRM_MINI_SITE_LINK */ .mgz),
        "footer.developers": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .SOFTWARE_MINI_SITE_LINK */ .DDD)
    };
    return acc;
}, {});
var LocalizedSolutionsFooterLinks = _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SUPPORTED_LOCALE_IDS.reduce(function(acc, localeId) {
    acc[localeId] = {
        "footer.enterprise": "/lang/".concat(localeId).concat(constants_links__WEBPACK_IMPORTED_MODULE_1__/* .ENTERPRISE_OLD_PAGE_LINK */ .Bhn)
    };
    return acc;
}, {});
// SUPPORTED_LOCALE_IDS
var getLocalizedLink = function(link, localeId) {
    var _DEFAULT_LINKS_link;
    var localizedLinks = LocalizedResourcesLinks[localeId];
    return localizedLinks && localizedLinks[link] ? localizedLinks[link].href : ((_DEFAULT_LINKS_link = DEFAULT_LINKS[link]) === null || _DEFAULT_LINKS_link === void 0 ? void 0 : _DEFAULT_LINKS_link.href) || link;
};


/***/ }),

/***/ 95333:
/***/ (function(module) {

//  names of translation projects supported by cluster service

var HOMEPAGE_PROJECT = "homepage"; // All the website static translations
var GENERATOR_PROJECT = "lp_generator"; // Page translations jobs data
var ALL_TRANSLATION_PROJECTS = [
    HOMEPAGE_PROJECT,
    GENERATOR_PROJECT
];
module.exports = {
    HOMEPAGE_PROJECT: HOMEPAGE_PROJECT,
    GENERATOR_PROJECT: GENERATOR_PROJECT,
    ALL_TRANSLATION_PROJECTS: ALL_TRANSLATION_PROJECTS
};


/***/ }),

/***/ 46108:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _createSuper = (__webpack_require__(37735)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var ProviderKeys = __webpack_require__(15071);
var REFRESH_INTERVAL_MINUTES = 15 * 60;
var URL_BASE = "https://monday.com";
var TRANSLATIONS_URL_BASE = "".concat(URL_BASE, "/localization/get");
var TranslationsDataProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    _inherits(TranslationsDataProvider, BaseDataProvider);
    var _super = _createSuper(TranslationsDataProvider);
    function TranslationsDataProvider() {
        _classCallCheck(this, TranslationsDataProvider);
        return _super.apply(this, arguments);
    }
    _createClass(TranslationsDataProvider, [
        {
            key: "key",
            value: function key() {
                var ref = this.params(), localeId = ref.localeId, project = ref.project;
                return "".concat(ProviderKeys.TRANSLATIONS, "_locale_").concat(localeId, "_project_").concat(project);
            }
        },
        {
            key: "refreshInterval",
            value: function refreshInterval() {
                return REFRESH_INTERVAL_MINUTES;
            }
        },
        {
            key: "getData",
            value: function getData() {
                var _this = this;
                return _async_to_generator(function() {
                    var ref, localeId, project, useNewTranslationsApi, options, url, res, response, e;
                    return _tsGenerator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = _this.params(), localeId = ref.localeId, project = ref.project, useNewTranslationsApi = ref.useNewTranslationsApi;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                options = {
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    method: "GET"
                                };
                                url = "".concat(TRANSLATIONS_URL_BASE, "/").concat(localeId, "/").concat(project, "/").concat(useNewTranslationsApi);
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 2:
                                res = _state.sent();
                                if (!(res && res.status === 200)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    res.json()
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 4:
                                throw new Error(res.statusText);
                            case 5:
                                e = _state.sent();
                                trackBigBrainEventOnServer("translations_internal_fetch_error", {
                                    direct_object: e.message
                                });
                                console.error(e.message);
                                throw e;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TranslationsDataProvider;
}(BaseDataProvider);
module.exports = TranslationsDataProvider;


/***/ }),

/***/ 99952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Di": function() { return /* binding */ getTranslationsFromApi; },
/* harmony export */   "L8": function() { return /* binding */ getFooterComponents; },
/* harmony export */   "am": function() { return /* binding */ getHeaderComponents; }
/* harmony export */ });
/* unused harmony export isSupportedLocale */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10092);
/* harmony import */ var _constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31182);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72632);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_localization__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55551);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65023);
/* harmony import */ var _server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75422);
/* harmony import */ var _server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73645);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46108);
/* harmony import */ var _server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants_translations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95333);
/* harmony import */ var _constants_translations__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_constants_translations__WEBPACK_IMPORTED_MODULE_7__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var getFooterComponents = function(localeId, abTests) {
    var forceGetAllComponents = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, additionalProps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var pageClusterConfig = additionalProps.pageClusterConfig, useProductMiniSiteConfig = additionalProps.useProductMiniSiteConfig;
    var SlimFooterLinks = (0,_constants_links__WEBPACK_IMPORTED_MODULE_0__/* .slimFooterLinks */ .D80)(pageClusterConfig, {
        useProductMiniSiteConfig: useProductMiniSiteConfig
    });
    if (isSupportedLocale(localeId) && !forceGetAllComponents) return {
        MondayFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MondayFooterLinks */ .DLT, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedSolutionsFooterLinks */ .Co),
        FeaturesFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .FeaturesFooterLinks */ .YMm,
        ProductsFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ProductsFooterLinks */ .QmN, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedProductsFooterLinks */ .$s),
        MoreByMondayFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MoreByMondayFooterLinks */ .AVb,
        OurProductFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinks */ .I5d,
        OurProductFooterLinksV2: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinksV2 */ .uO1, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedOurProductFooterLinksV2 */ .yt),
        OurTeamFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinks */ .Ia5,
        OurTeamFooterLinksV2: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinksV2 */ .J$8,
        ResourcesFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ResourcesFooterLinks */ .PvX, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedResourcesLinks */ .nQ),
        HelpFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .HelpFooterLinks */ .bGv,
        NewSecurityFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .NewSecurityFooterLinks */ .BeP,
        SlimFooterLinks: SlimFooterLinks
    };
    return {
        MondayFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MondayFooterLinks */ .DLT, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedSolutionsFooterLinks */ .Co),
        FeaturesFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .FeaturesFooterLinks */ .YMm,
        ProductsFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ProductsFooterLinks */ .QmN, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedProductsFooterLinks */ .$s),
        MoreByMondayFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MoreByMondayFooterLinks */ .AVb,
        OurProductFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinks */ .I5d,
        OurProductFooterLinksV2: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinksV2 */ .uO1, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedOurProductFooterLinksV2 */ .yt),
        OurTeamFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinks */ .Ia5,
        OurTeamFooterLinksV2: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinksV2 */ .J$8,
        UseCasesFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .UseCasesFooterLinks */ .wkx,
        UseCasesFooterLinksV2: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .UseCasesFooterLinksV2 */ .Yly, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedUseCasesFooterLinks */ .Rj),
        ResourcesFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ResourcesFooterLinks */ .PvX, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedResourcesLinks */ .nQ),
        HelpFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .HelpFooterLinks */ .bGv,
        NewSecurityFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .NewSecurityFooterLinks */ .BeP,
        SlimFooterLinks: SlimFooterLinks
    };
};
var getHeaderComponents = function(localeId) {
    var showShortHeader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isSupportedLocale(localeId)) return _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .LocalizedHeader */ .kov;
    return showShortHeader ? _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ShortHeader */ .ha3 : _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .Header */ .h4i;
};
var isSupportedLocale = function(localeId) {
    var filteredArray = _constants_localization__WEBPACK_IMPORTED_MODULE_2__.SUPPORTED_LOCALE_IDS.filter(function(supportedLocale) {
        return supportedLocale === localeId;
    });
    return filteredArray.length > 0;
};
var updateLocalizedStaticLinks = function(localeId, resourceLinks, allLocalesLocalizedLinks) {
    var localeLocalizedLinks = allLocalesLocalizedLinks[localeId];
    var localizedLinks = _object_spread({}, resourceLinks.links, localeLocalizedLinks);
    // Filter the localizedLinks to only include keys that start with "footer"
    var filteredLinks = Object.fromEntries(Object.entries(localizedLinks).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return key.startsWith("footer");
    }));
    return _object_spread_props(_object_spread({}, resourceLinks), {
        links: filteredLinks
    });
};
var getTranslationsFromApi = function() {
    var _ref = _async_to_generator(function(localeId, useNewTranslationsApi) {
        var translations, provider, exception;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isSupportedLocale(localeId)) return [
                        2,
                        services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_3__
                    ];
                    translations = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    provider = new (_server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6___default())({
                        localeId: localeId,
                        project: _constants_translations__WEBPACK_IMPORTED_MODULE_7__.HOMEPAGE_PROJECT,
                        useNewTranslationsApi: useNewTranslationsApi
                    });
                    return [
                        4,
                        (0,_server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5__.getCachedData)(provider)
                    ];
                case 2:
                    translations = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    exception = _state.sent();
                    (0,_server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__.trackBigBrainEventOnServer)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_10__.TRANSLATIONS_INTERNAL_ERROR, {
                        info1: exception.message,
                        info2: localeId
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        _object_spread({}, services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_3__, translations)
                    ];
            }
        });
    });
    return function getTranslationsFromApi(localeId, useNewTranslationsApi) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);